import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DataLifecycleHandler } from '@luzula/luzula-lib';
import { DataService } from '../../data.service';

/**
 * Handler für Daten-Lifecycle-Events.
 * Leitet die Events vom DataService weiter.
 */
@Injectable({ providedIn: 'root' })
export class BohrpunktDataLifecycleHandler implements DataLifecycleHandler {
	private ds = inject(DataService);

	get checkedOut$(): Observable<void> {
		return this.ds.checkedOut;
	}

	get checkedIn$(): Observable<void> {
		return this.ds.checkedIn;
	}

	get discarded$(): Observable<void> {
		return this.ds.discarded;
	}
}
